import { memo } from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { authDataService } from "src/app/services/data/auth.data.service";
import { UserRole } from "src/app/@types/enums/user.roles";
import { getBannerImage } from "./contentHelper";
import YouthContent from "./components/YouthContent";
import HostContent from "./components/HostContent";
import AdminContent from "./components/AdminContent";
import ParentContent from "./components/ParentContent";
import React from "react";

const DemoContent: React.FC = () => {
  const { t } = useTranslation("demoContentPage");
  const theme = useTheme();

  // Render appropriate content based on user role
  const renderContentByRole = () => {
    switch (authDataService.userRoleId) {
      case UserRole.Youth:
        return <YouthContent theme={theme} getBannerImage={getBannerImage} />;
      case UserRole.Host:
        return <HostContent theme={theme} getBannerImage={getBannerImage} />;
      case UserRole.Admin:
        return <AdminContent theme={theme} getBannerImage={getBannerImage} />;
      case UserRole.Parent:
        return <ParentContent theme={theme} getBannerImage={getBannerImage} />;
      default:
        return <YouthContent theme={theme} getBannerImage={getBannerImage} />; // Default to Youth content
    }
  };

  return renderContentByRole();
};

export default memo(DemoContent);
